var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropshippingStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241,
    height: 32,
    viewBox: "0 0 241 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22381",
    "data-name": "\\uADF8\\uB8F9 22381",
    transform: "translate(15504 -7531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20120",
    "data-name": "\\uADF8\\uB8F9 20120",
    transform: "translate(-15504 7531)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1179",
    "data-name": "\\uD0C0\\uC6D0 1179",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(9 23)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1179-2",
    "data-name": "\\uD0C0\\uC6D0 1179",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15468 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1607",
    "data-name": "\\uD0C0\\uC6D0 1607",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15398 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1617",
    "data-name": "\\uD0C0\\uC6D0 1617",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15328 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1583",
    "data-name": "\\uD0C0\\uC6D0 1583",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15464 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1608",
    "data-name": "\\uD0C0\\uC6D0 1608",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15394 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1616",
    "data-name": "\\uD0C0\\uC6D0 1616",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15324 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1584",
    "data-name": "\\uD0C0\\uC6D0 1584",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15460 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1609",
    "data-name": "\\uD0C0\\uC6D0 1609",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15390 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1614",
    "data-name": "\\uD0C0\\uC6D0 1614",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15320 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1585",
    "data-name": "\\uD0C0\\uC6D0 1585",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15456 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1602",
    "data-name": "\\uD0C0\\uC6D0 1602",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15386 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1615",
    "data-name": "\\uD0C0\\uC6D0 1615",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15316 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1586",
    "data-name": "\\uD0C0\\uC6D0 1586",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15452 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1603",
    "data-name": "\\uD0C0\\uC6D0 1603",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15382 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1613",
    "data-name": "\\uD0C0\\uC6D0 1613",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15312 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1587",
    "data-name": "\\uD0C0\\uC6D0 1587",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15448 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1604",
    "data-name": "\\uD0C0\\uC6D0 1604",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15378 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1610",
    "data-name": "\\uD0C0\\uC6D0 1610",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15308 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1600",
    "data-name": "\\uD0C0\\uC6D0 1600",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15444 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1605",
    "data-name": "\\uD0C0\\uC6D0 1605",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15374 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1611",
    "data-name": "\\uD0C0\\uC6D0 1611",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15304 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1601",
    "data-name": "\\uD0C0\\uC6D0 1601",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15440 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1606",
    "data-name": "\\uD0C0\\uC6D0 1606",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15370 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1612",
    "data-name": "\\uD0C0\\uC6D0 1612",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(-15300 7546)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20121",
    "data-name": "\\uADF8\\uB8F9 20121",
    transform: "translate(-15433.822 7531)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1180",
    "data-name": "\\uD0C0\\uC6D0 1180",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-0.178)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(9.822 23)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20122",
    "data-name": "\\uADF8\\uB8F9 20122",
    transform: "translate(-15363.628 7531)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1181",
    "data-name": "\\uD0C0\\uC6D0 1181",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-0.372)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(9.628 23)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21025",
    "data-name": "\\uADF8\\uB8F9 21025",
    transform: "translate(-15294.45 7531)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_1181-2",
    "data-name": "\\uD0C0\\uC6D0 1181",
    cx: 15.5,
    cy: 16,
    rx: 15.5,
    ry: 16,
    transform: "translate(0.45)",
    fill: "#adb5bd"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(8.45 23)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropshippingStep1);
export default __webpack_public_path__ + "static/media/DropshippingStep1.718b1e8962937019d198f54befd0e2a5.svg";
export { ForwardRef as ReactComponent };